import { createSlice } from '@reduxjs/toolkit';
import { get } from '../../services/apiController';

const initialState = {
  categories: [],
  totalRecords: 0,
};

const CakeCategorySlice = createSlice({
  name: 'CakeCategorySlice',
  initialState,
  reducers: {
    setCategories(state, action) {
      state.categories = action?.payload;
    },
    setTotalRecords(state, action) {
      state.totalRecords = action?.payload;
    },
  },
});

export const FetchCategories = (query) => async (dispatch) => {
  try {
    let url = '/cake/categories/?type=parent';
    if (query) {
      url += query;
    }
    get(url)
      .then((res) => {
        dispatch(setCategories(res?.data?.rows));
        dispatch(setTotalRecords(res?.data?.count));
      })
      .catch((err) => {
        console.log('error', err);
      });
  } catch (e) {
    console.log('error', e);
  }
};

export const { setCategories, setTotalRecords } = CakeCategorySlice.actions;
export default CakeCategorySlice.reducer;
